/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ e: NonNullable<unknown> }} Intervention_Plan_Add_To_Pdf_ErrorInputs */



/**
* | output |
* | --- |
* | "An error occurred while adding the plan to the PDF: {e}" |
*
* @param {Intervention_Plan_Add_To_Pdf_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_add_to_pdf_error = /** @type {((inputs: Intervention_Plan_Add_To_Pdf_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Add_To_Pdf_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`An error occurred while adding the plan to the PDF: ${i?.e}`)
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de l'ajout du plan au pdf : ${i?.e}`)
});